import React, { useState } from 'react';
import LoginFormUsernameField from '../presentations/Login/LoginFormUsernameField';
import LoginFormForgotPassword from '../presentations/Login/LoginFormForgotPassword';
import LoginFormLayout from '../presentations/Login/LoginFormLayout';
import LoginFormPasswordField from '../presentations/Login/LoginFormPasswordField';
import { useHistory } from 'react-router';
import { useForm } from 'react-hook-form';
import FormErrorText from '../presentations/Form/FormErrorText';
import { syncSessionMetadata } from '../services/auth-token-storage';
import { AppInitializer } from '../services/app-initializer';
import { UserType } from '../stores/authenticated';
import { InfoType } from '../App';
import Button from '../presentations/Button';
import Spinner2 from '../presentations/Spinner2';
import { SystemType } from '../stores/system';
import { useTranslation } from 'react-i18next';
import Repository from '../services/repository';
import { ApiResponse } from '../services/api';

type loginResponse = {
  user: UserType;
  accessTokenExpiresAt: number;
};

type loginFormValues = {
  loginId: string;
  password: string;
};

const LoginForm: React.FC = () => {
  const { register, handleSubmit, errors } = useForm<loginFormValues>();
  const [errorMessage, setErrorMessage] = useState();
  const [sending, setSending] = useState(false);
  const history = useHistory();
  const repository = new Repository();
  const { t } = useTranslation();

  const onSubmit = (post: loginFormValues): void => {
    setSending(true);

    repository
      .signin(post)
      .then(({ data }: ApiResponse<loginResponse>) => {
        const { user, accessTokenExpiresAt } = data;

        syncSessionMetadata(accessTokenExpiresAt, { syncRedux: false });

        initialize(accessTokenExpiresAt, user);
      })
      .catch(() => {
        setSending(false);
        setErrorMessage(t('Wrong email address/username or password'));
      });
  };

  const initialize = (accessTokenExpiresAt: number, user: UserType): void => {
    AppInitializer.dataLoad()
      .then((response: ApiResponse<InfoType | SystemType>[]) => {
        const info = response[0] as ApiResponse<InfoType>;
        const system = response[1] as ApiResponse<SystemType>;

        AppInitializer.loggedIn({
          accessTokenExpiresAt,
          userId: user.id as number,
          user: user as UserType,
          info: info.data,
          system: system.data,
        });
        history.push('/');
      })
      .catch(() => {
        setSending(false);
        setErrorMessage(t('A problem has occurred. Please try again in a few minutes.'));
      });
  };

  return (
    <LoginFormLayout title={t('Login')} onSubmit={handleSubmit(onSubmit)}>
      {errorMessage && <FormErrorText text={errorMessage} />}
      <LoginFormUsernameField register={register({ required: true })} error={errors.loginId} />
      <LoginFormPasswordField register={register({ required: true })} error={errors.password} />
      <Button type={'submit'} color={'secondary'} width={'100%'} fontSize={14}>
        {sending ? <Spinner2 /> : null} {t('Login')}
      </Button>
      <LoginFormForgotPassword />
    </LoginFormLayout>
  );
};

export default LoginForm;
